// extracted by mini-css-extract-plugin
export default {"tokenName":"nFIUi5_8zT6STLxhDBg6"};